import { render, staticRenderFns } from "./ShouHuoLocation.vue?vue&type=template&id=627bce13&"
import script from "./ShouHuoLocation.vue?vue&type=script&lang=ts&"
export * from "./ShouHuoLocation.vue?vue&type=script&lang=ts&"
import style0 from "./ShouHuoLocation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports